/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {openChat} from '../api'

export const useMutationOpenChat = createReactQueryMutationHook('openChat', openChat)
